import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {MyApp} from './app.component';
import {HomePage} from '../pages/home/home';
import {ComponentsModule} from "../components/components.module";
import {PipesModule} from "../pipes/pipes.module";
import {ContentTranslationProvider} from '../providers/content-translation/content-translation';
import {IntroWizardServiceProvider} from '../providers/intro-wizard-service/intro-wizard-service';
import {ApiProvider} from '../providers/api/api';
import {ApiAuthProvider} from '../providers/api-auth/api-auth';
import {UserStateProvider} from '../providers/user-state/user-state';
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {ApiStepCounterProvider} from '../providers/api-step-counter/api-step-counter';
import {InitWizardProvider} from '../providers/init-wizard/init-wizard';
import {Deeplinks} from "@ionic-native/deeplinks";
import {ApiInitProvider} from '../providers/api-init/api-init';
import {ApiCourseDataProvider} from '../providers/api-course-data/api-course-data';
import {UserProgressStateProvider} from '../providers/user-progress-state/user-progress-state';
import {ApiUserProgressProvider} from '../providers/api-user-progress/api-user-progress';
import {UserStatsProvider} from '../providers/user-stats/user-stats';
import {DatePickerModule} from "ion-datepicker";
import {UserTagProvider} from '../providers/user-tag/user-tag';
import {StepCounterEngineProvider} from '../providers/step-counter-engine/step-counter-engine';
import {ChatClientProvider} from '../providers/chat-client/chat-client';
import {DirectivesModule} from "../directives/directives.module";
import {AppVersion} from "@ionic-native/app-version";
import {NgCircleProgressModule} from "ng-circle-progress";
import {Push} from "@ionic-native/push";
import {InsuranceProvider} from '../providers/insurance/insurance';
import {ApiForumProvider} from '../providers/api-forum/api-forum';
import {CalendarModule} from "ion2-calendar";
import {registerLocaleData} from "@angular/common";

import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import {WheelSelector} from "@ionic-native/wheel-selector";
import {PopupUpdateGoalProvider} from '../providers/popup-update-goal/popup-update-goal';
import {ChatStateProvider} from '../providers/chat-state/chat-state';
import {AppChatPageModule} from "../pages/app-chat/app-chat.module";
import {AppAccountRemovalPageModule} from "../pages/app-account-removal/app-account-removal.module";
import {InitStepCounterPageModule} from "../pages/init-step-counter/init-step-counter.module";
import {AppForumTopicCreatePageModule} from "../pages/app-forum-topic-create/app-forum-topic-create.module";
import {InitPreferenceStep2PageModule} from "../pages/init-preference-step2/init-preference-step2.module";
import {AppMoodTrackerPageModule} from "../pages/app-mood-tracker/app-mood-tracker.module";
import {AppPopupEvaluationPageModule} from "../pages/app-popup-evaluation/app-popup-evaluation.module";
import {AppVideoTipsPageModule} from "../pages/app-video-tips/app-video-tips.module";
import {AppSettingsTrainingPopupPageModule} from "../pages/app-settings-training-popup/app-settings-training-popup.module";
import {AppStepUpdatePageModule} from "../pages/app-step-update/app-step-update.module";
import {AppFeedbackPageModule} from "../pages/app-feedback/app-feedback.module";
import {AppPartnerSelectionPopupPageModule} from "../pages/app-partner-selection-popup/app-partner-selection-popup.module";
import {InitMoodTrackerPageModule} from "../pages/init-mood-tracker/init-mood-tracker.module";
import {AppModuleListPageModule} from "../pages/app-module-list/app-module-list.module";
import {AppVideoQuizPageModule} from "../pages/app-video-quiz/app-video-quiz.module";
import {AppVideoPlayerPageModule} from "../pages/app-video-player/app-video-player.module";
import {AppPaymentPageModule} from "../pages/app-payment/app-payment.module";
import {AppForumListPageModule} from "../pages/app-forum-list/app-forum-list.module";
import {AppMoodUpdatePageModule} from "../pages/app-mood-update/app-mood-update.module";
import {RegisterPageModule} from "../pages/register/register.module";
import {LoginPageModule} from "../pages/login/login.module";
import {AppPasswordChangePageModule} from "../pages/app-password-change/app-password-change.module";
import {PasswordForgottenPageModule} from "../pages/password-forgotten/password-forgotten.module";
import {AppSettingsGoalPageModule} from "../pages/app-settings-goal/app-settings-goal.module";
import {AppStatsPageModule} from "../pages/app-stats/app-stats.module";
import {InitPreferenceStep1PageModule} from "../pages/init-preference-step1/init-preference-step1.module";
import {InitBackpainTrackerPageModule} from "../pages/init-backpain-tracker/init-backpain-tracker.module";
import {AppStepCounterPageModule} from "../pages/app-step-counter/app-step-counter.module";
import {IntroChooseInsurranceCompanyPageModule} from "../pages/intro-choose-insurrance-company/intro-choose-insurrance-company.module";
import {InitBackpainLevelPageModule} from "../pages/init-backpain-level/init-backpain-level.module";
import {ModalTeamInfoPageModule} from "../pages/modal-team-info/modal-team-info.module";
import {DatePickerPopoverPageModule} from "../pages/date-picker-popover/date-picker-popover.module";
import {InitSummaryPageModule} from "../pages/init-summary/init-summary.module";
import {AppDashboardPageModule} from "../pages/app-dashboard/app-dashboard.module";
import {AppVideoMyWayPageModule} from "../pages/app-video-my-way/app-video-my-way.module";
import {SettingsPopoverPageModule} from "../pages/settings-popover/settings-popover.module";
import {AppWhoQuestionnairePageModule} from "../pages/app-who-questionnaire/app-who-questionnaire.module";
import {AppChatDetailsPageModule} from "../pages/app-chat-details/app-chat-details.module";
import {IntroNamePageModule} from "../pages/intro-name/intro-name.module";
import {InitHelloPageModule} from "../pages/init-hello/init-hello.module";
import {AppVideoPlusPageModule} from "../pages/app-video-plus/app-video-plus.module";
import {AppForumPostsPageModule} from "../pages/app-forum-posts/app-forum-posts.module";
import {IntroInsurranceValidationPageModule} from "../pages/intro-insurrance-validation/intro-insurrance-validation.module";
import {AppModuleDetailsPageModule} from "../pages/app-module-details/app-module-details.module";
import {AppForumTopicResponsePageModule} from "../pages/app-forum-topic-response/app-forum-topic-response.module";
import {AppVideoDetailsPageModule} from "../pages/app-video-details/app-video-details.module";
import {AppMyWayPageModule} from "../pages/app-my-way/app-my-way.module";
import {AppForumTopicsPageModule} from "../pages/app-forum-topics/app-forum-topics.module";
import {AppSettingsTrainingPageModule} from "../pages/app-settings-training/app-settings-training.module";
import {SplashPageModule} from "../pages/splash/splash.module";
import {PasswordForgottenUpdatePageModule} from "../pages/password-forgotten-update/password-forgotten-update.module";
import {IntroDescriptionPageModule} from "../pages/intro-description/intro-description.module";
import {AppPopupEvaluationMailSentPageModule} from "../pages/app-popup-evaluation-mail-sent/app-popup-evaluation-mail-sent.module";
import {IntroWelcomePageModule} from "../pages/intro-welcome/intro-welcome.module";
import {IonicStorageModule} from "@ionic/storage";
import {LocalStorageWrapper} from "../providers/local-storage-wrapper/local-storage-wrapper";
import {AppRegistrationStartPageModule} from "../pages/app-registration-start/app-registration-start.module";
import {IntroInsuranceConfirmationPageModule} from "../pages/intro-insurance-confirmation/intro-insurance-confirmation.module";
import {IntroAokSelectionPage} from "../pages/intro-aok-selection/intro-aok-selection";
import {IntroAokSelectionPageModule} from "../pages/intro-aok-selection/intro-aok-selection.module";
import {AppYubleCodePopupPageModule} from "../pages/app-yuble-code-popup/app-yuble-code-popup.module";
import {AppRegistrationYubleSelectionPageModule} from "../pages/app-registration-yuble-selection/app-registration-yuble-selection.module";
import {AppPausePageModule} from "../pages/app-pause/app-pause.module";
import {InitPrescriptionPageModule} from "../pages/init-prescription/init-prescription.module";
import {AppStatsIntroPageModule} from "../pages/app-stats-intro/app-stats-intro.module";
import {AppWeightUpdatePageModule} from "../pages/app-weight-update/app-weight-update.module";
import {AppWeightUpdateGoalPageModule} from "../pages/app-weight-update-goal/app-weight-update-goal.module";
import {AppStatsFoodPageModule} from "../pages/app-stats-food/app-stats-food.module";
import {AppStatsFoodUpdatePageModule} from "../pages/app-stats-food-update/app-stats-food-update.module";
import {
  AppFoodTrackingInfoPopupPageModule
} from "../pages/app-food-tracking-info-popup/app-food-tracking-info-popup.module";
import {AppChallengeIntroPage} from "../pages/app-challenge-intro/app-challenge-intro";
import {AppChallengeIntroPageModule} from "../pages/app-challenge-intro/app-challenge-intro.module";
import {AppChallengeInAppPageModule} from "../pages/app-challenge-in-app/app-challenge-in-app.module";
import {AppChallengeUserPageModule} from "../pages/app-challenge-user/app-challenge-user.module";
import { ChallengeProvider } from '../providers/challenge/challenge';
import {
  AppChallengeUserPopupStartPageModule
} from "../pages/app-challenge-user-popup-start/app-challenge-user-popup-start.module";
import {
  AppChallengeUserPopupAchievedPageModule
} from "../pages/app-challenge-user-popup-achieved/app-challenge-user-popup-achieved.module";
import {
  AppChallengeUserPopupCompletionRequestPageModule
} from "../pages/app-challenge-user-popup-completion-request/app-challenge-user-popup-completion-request.module";
import {DebugPageModule} from "../pages/debug/debug.module";


@NgModule({
  declarations: [
    MyApp,
    HomePage,
  ],
  imports: [
    BrowserModule,
    NgCircleProgressModule.forRoot({
    }),
    IonicStorageModule.forRoot(),
    ComponentsModule,
    DirectivesModule,
    PipesModule,
    CalendarModule,
    DatePickerModule,
    IonicModule.forRoot(MyApp, {mode: 'md', scrollPadding: false, navExitApp: false}),
    AppChatPageModule,
    AppAccountRemovalPageModule,
    IntroWelcomePageModule,
    IntroNamePageModule,
    IntroInsurranceValidationPageModule,
    LoginPageModule,
    RegisterPageModule,
    PasswordForgottenPageModule,
    PasswordForgottenUpdatePageModule,
    InitHelloPageModule,
    InitPreferenceStep1PageModule,
    InitPreferenceStep2PageModule,
    InitStepCounterPageModule,
    IntroChooseInsurranceCompanyPageModule,
    IntroDescriptionPageModule,
    InitMoodTrackerPageModule,
    InitBackpainTrackerPageModule,
    InitPrescriptionPageModule,
    AppDashboardPageModule,
    AppModuleListPageModule,
    AppModuleDetailsPageModule,
    AppVideoDetailsPageModule,
    AppVideoPlayerPageModule,
    AppVideoQuizPageModule,
    AppVideoMyWayPageModule,
    AppChatDetailsPageModule,
    AppStepUpdatePageModule,
    AppMoodUpdatePageModule,
    AppStatsPageModule,
    AppMyWayPageModule,
    AppVideoPlusPageModule,
    AppVideoTipsPageModule,
    AppPaymentPageModule,
    AppPasswordChangePageModule,
    AppStepCounterPageModule,
    AppMoodTrackerPageModule,
    AppWhoQuestionnairePageModule,
    AppFeedbackPageModule,
    InitBackpainLevelPageModule,
    InitSummaryPageModule,
    SplashPageModule,
    SettingsPopoverPageModule,
    ModalTeamInfoPageModule,
    AppForumListPageModule,
    AppForumPostsPageModule,
    AppForumTopicsPageModule,
    AppForumTopicResponsePageModule,
    AppForumTopicCreatePageModule,
    AppSettingsTrainingPageModule,
    AppSettingsTrainingPopupPageModule,
    AppPopupEvaluationPageModule,
    AppSettingsGoalPageModule,
    DatePickerPopoverPageModule,
    AppPopupEvaluationMailSentPageModule,
    AppPartnerSelectionPopupPageModule,
    AppRegistrationStartPageModule,
    IntroInsuranceConfirmationPageModule,
    IntroAokSelectionPageModule,
    AppYubleCodePopupPageModule,
    AppRegistrationYubleSelectionPageModule,
    AppPausePageModule,
    AppStatsIntroPageModule,
    AppWeightUpdatePageModule,
    AppWeightUpdateGoalPageModule,
    AppStatsFoodPageModule,
    AppStatsFoodUpdatePageModule,
    AppFoodTrackingInfoPopupPageModule,
    AppChallengeIntroPageModule,
    AppChallengeInAppPageModule,
    AppChallengeUserPageModule,
    AppChallengeUserPopupStartPageModule,
    AppChallengeUserPopupAchievedPageModule,
    AppChallengeUserPopupCompletionRequestPageModule,
    DebugPageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    WheelSelector,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: LOCALE_ID, useValue: 'de-DE'},
    ContentTranslationProvider,
    IntroWizardServiceProvider,
    LocalStorageWrapper,
    ApiProvider,
    InsuranceProvider,
    ApiAuthProvider,
    UserStateProvider,
    InAppBrowser,
    AppVersion,
    ApiStepCounterProvider,
    InitWizardProvider,
    Deeplinks,
    ApiInitProvider,
    ApiCourseDataProvider,
    UserProgressStateProvider,
    ApiUserProgressProvider,
    UserStatsProvider,
    UserTagProvider,
    StepCounterEngineProvider,
    ChatClientProvider,
    Push,
    InsuranceProvider,
    ApiForumProvider,
    PopupUpdateGoalProvider,
    ChatStateProvider,
    ChallengeProvider,
  ]
})
export class AppModule {}

registerLocaleData(localeDe, 'de-DE', localeDeExtra);



// WEBPACK FOOTER //
// ./src/app/app.module.ts